module.exports = __webpack_public_path__ + "img/9788960499263.afdedf3b.jpg";